<template>
    <div class="customer-information">
        <div class="title">Customer Information</div>
        <validation-observer name="Customer" ref="validateCustomer">
            <b-card class="b-card-bg">
                <b-row class="px-2">
                    <b-col cols="12" lg="4">
                        <validation-provider
                            name="Company name"
                            #default="{ errors }"
                            rules="required"
                        >
                            <b-form-group>
                                <label class="flex"
                                    >Company name
                                    <span class="red">*</span></label
                                >

                                <Select4
                                    :disabled="readonly"
                                    :class="
                                        errors.length > 0 ? 'is-invalid' : null
                                    "
                                    class="select2-v2"
                                    rules="required"
                                    :key="componentKey"
                                    placeholder="Enter your customer's name"
                                    v-model="value.company_id"
                                    @select="
                                        () => {
                                            value.customer_id = '';
                                            onSelectService();
                                        }
                                    "
                                    @change="updateAllSelects"
                                    :options="{
                                        isSearch: true,
                                        value: 'code',
                                        label: 'text',
                                        data: company_list,
                                        fields: [
                                            {
                                                field: 'name',
                                                label: 'Company name',
                                            },
                                            {
                                                field: 'acronym',
                                                label: 'Acronym',
                                            },
                                        ],
                                    }"
                                />

                                <small
                                    class="text-danger"
                                    v-show="errors.length > 0"
                                    >{{ errors[0] }}</small
                                >
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <validation-provider
                            name="Company address"
                            #default="{ errors }"
                            rules="required"
                        >
                            <b-form-group>
                                <label class="flex"
                                    >Company address
                                    <span class="red">*</span></label
                                >

                                <Select4
                                    :disabled="readonly"
                                    :class="
                                        errors.length > 0 ? 'is-invalid' : null
                                    "
                                    class="select2-v2"
                                    :key="componentKey"
                                    rules="required"
                                    placeholder="Enter your customer's address"
                                    v-model="value.company_id"
                                    @change="updateAllSelects"
                                    :options="{
                                        isSearch: true,
                                        value: 'code',
                                        label: 'text',
                                        data: company_list,
                                        fields: [
                                            {
                                                field: 'address',
                                                label: 'Company address',
                                            },
                                        ],
                                    }"
                                    @select="
                                        () => {
                                            value.customer_id = '';
                                            onSelectService();
                                        }
                                    "
                                />
                                <small
                                    class="text-danger"
                                    v-show="errors.length > 0"
                                    >{{ errors[0] }}</small
                                >
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <validation-provider
                            name="Tax code"
                            #default="{ errors }"
                            rules="required"
                        >
                            <b-form-group>
                                <label class="flex"
                                    >Tax code <span class="red">*</span></label
                                >

                                <Select4
                                    :disabled="readonly"
                                    :class="
                                        errors.length > 0 ? 'is-invalid' : null
                                    "
                                    @change="updateAllSelects"
                                    class="select2-v2"
                                    :key="componentKey"
                                    rules="required"
                                    placeholder="Enter your customer's tax code"
                                    v-model="value.company_id"
                                    @select="
                                        () => {
                                            value.customer_id = '';
                                            onSelectService();
                                        }
                                    "
                                    :options="{
                                        isSearch: true,
                                        value: 'code',
                                        label: 'text',
                                        data: company_list,
                                        fields: [
                                            {
                                                field: 'code',
                                                label: 'Tax Code',
                                            },
                                        ],
                                    }"
                                />
                                <small
                                    class="text-danger"
                                    v-show="errors.length > 0"
                                    >{{ errors[0] }}</small
                                >
                            </b-form-group>
                        </validation-provider>
                    </b-col>

                    <b-col cols="12" lg="4">
                        <validation-provider
                            name="Name"
                            #default="{ errors }"
                            rules="required"
                        >
                            <b-form-group>
                                <label class="flex"
                                    >To whom will this booking be released?

                                    <span class="red">*</span></label
                                >
                                <b-row>
                                    <b-col cols="6">
                                        <b-form-group>
                                            <Select4
                                                :class="
                                                    errors.length > 0
                                                        ? 'is-invalid'
                                                        : null
                                                "
                                                :disabled="
                                                    readonly ||
                                                    !value.company_id
                                                "
                                                class="select2-v2"
                                                :key="componentKey"
                                                rules="required"
                                                :settings="{
                                                    dropdownCssClass:
                                                        'select2-v2',
                                                }"
                                                placeholder="Name"
                                                v-model="value.customer_id"
                                                @select="onSelectService()"
                                                :options="{
                                                    isSearch: true,
                                                    value: 'code',
                                                    label: 'name',
                                                    data: customer_list_options,
                                                    fields: [
                                                        {
                                                            field: 'name',
                                                            label: 'Name',
                                                        },
                                                    ],
                                                }"
                                            />
                                            <small
                                                class="text-danger"
                                                v-show="errors.length > 0"
                                                >{{ errors[0] }}</small
                                            >
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="6">
                                        <b-form-group>
                                            <Select4
                                                :class="
                                                    errors.length > 0
                                                        ? 'is-invalid'
                                                        : null
                                                "
                                                :disabled="
                                                    readonly ||
                                                    !value.company_id
                                                "
                                                class="select2-v2"
                                                :key="componentKey"
                                                rules="required"
                                                :settings="{
                                                    dropdownCssClass:
                                                        'select2-v2',
                                                }"
                                                placeholder="Phone"
                                                v-model="value.customer_id"
                                                @select="onSelectService()"
                                                :options="{
                                                    isSearch: true,
                                                    value: 'code',
                                                    label: 'mobile',
                                                    data: customer_list_options,
                                                    fields: [
                                                        {
                                                            field: 'mobile',
                                                            label: 'Phone',
                                                        },
                                                    ],
                                                }"
                                            />
                                            <small
                                                class="text-danger"
                                                v-show="errors.length > 0"
                                                >{{ errors[0] }}</small
                                            >
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <validation-provider
                            name="Customer's email"
                            #default="{ errors }"
                            rules="required"
                        >
                            <label class="mt-1"></label>
                            <b-form-group>
                                <Select4
                                    :class="
                                        errors.length > 0 ? 'is-invalid' : null
                                    "
                                    :disabled="readonly || !value.company_id"
                                    class="select2-v2"
                                    :key="componentKey"
                                    rules="required"
                                    placeholder="Enter your customer's email"
                                    v-model="value.customer_id"
                                    @select="onSelectService()"
                                    :options="{
                                        isSearch: true,
                                        value: 'code',
                                        label: 'email',
                                        data: customer_list_options,
                                        fields: [
                                            {
                                                field: 'email',
                                                label: 'Email',
                                            },
                                        ],
                                    }"
                                />
                                <small
                                    class="text-danger"
                                    v-show="errors.length > 0"
                                    >{{ errors[0] }}</small
                                >
                            </b-form-group>
                        </validation-provider>
                    </b-col>
                </b-row>
            </b-card>
        </validation-observer>
    </div>
</template>

<script>
import Select2 from "v-select2-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import useJwt from "@/auth/jwt/useJwt";
import {
    BButton,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormDatepicker,
    BRow,
    BCol,
    BTable,
    BCard,
} from "bootstrap-vue";
export default {
    components: {
        BButton,
        ValidationProvider,
        ValidationObserver,

        BFormGroup,
        BInputGroup,
        BInputGroupAppend,
        BInputGroupPrepend,
        BFormDatepicker,
        BRow,
        BCol,
        BTable,
        BCard,

        Select2,
    },
    data() {
        return {
            componentKey: 0,
            userData: JSON.parse(localStorage.getItem("userData")),
            customer_list_options: null,
        };
    },
    props: {
        value: {
            type: Object,
        },

        readonly: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState("masterData", [
            "service_types",
            "ports",
            "incoterms",
            "cont_types",
            "goods_types",
            "transport_types",
            "deports_locations",
            "deports",
            "business_types",
            "customs_types",
            "shipping_lines",
            "regions",
            "companyItems",
            "fee_types",
            "handed_types",
        ]),
        company_list() {
            return this.companyItems;
        },
    },
    methods: {
        onSelectService(e) {
            this.$emit("onServiceType");
            this.componentKey++;
        },
        updateAllSelects() {},
    },

    watch: {
        "value.company_id": function (n, o) {
            
            if (
                this.userData.userType ==
                    this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale ||
                this.userData.userType ==
                    this.$Utils.CONSTANTS.USER_TYPE_O.Admin
            ) {
                useJwt
                    .get("wr1?objectType=CustomerListCompany", {
                        params: { search: n },
                    })
                    .then((response) => {
                        this.customer_list_options = response.data.result;

                        if (this.value.customer_id == null) {
                            this.value.customer_id =
                                this.customer_list_options.filter(
                                    (e) => e.user_type == 2
                                )[0]?.code;
                        }
                        this.componentKey++;
                    });
            }
        },
    },
};
</script>

<style lang="scss">
.customer-information {
    label {
        color: #000000;
        font-weight: 600;
    }
    .b-card-bg {
        height: 250px;
        @media (max-width: 992px) {
            height: 450px;
        }
    }
    .form-control {
        border: none !important;
    }
    //   .select2 {
    //     height: 28px !important;
    //   }
}
</style>
